import React, { useState, useCallback } from "react";
import { useNavigate, Link } from "react-router-dom";
import OtpInput from "react-otp-input";
import { useDispatch } from "react-redux";
import { verifyNumber, verifyOtp, hospitalReg } from "../apiCalls/user";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialValues = {
    labName: "",
    labEmail: "",
    mobileNumber: "",
    password: "",
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [otp, setOtp] = useState("");
  const [otpField, setOtpField] = useState(false);
  const [regField, setRegField] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [otpCooldown, setOtpCooldown] = useState(0);

  const validate = (values, step) => {
    const errors = {};

    if (step === "initial" || step === "registration") {
      if (!values.labName || /^[ ]+$/.test(values.labName) || !/^[a-zA-Z0-9 ]+$/.test(values.labName)) {
        errors.labName = "Name is not valid";
      }
      if (!values.labEmail) {
        errors.labEmail = "Email is required";
      } else if (!/^\S+@\S+\.\S+$/.test(values.labEmail)) {
        errors.labEmail = "Invalid email format";
      }
      if (!values.mobileNumber) {
        errors.mobileNumber = "Number is required";
      } else if (!/^[0-9]{10}$/.test(values.mobileNumber)) {
        errors.mobileNumber = "Invalid number";
      }
    }

    if (step === "registration") {
      if (!values.password) {
        errors.password = "Password is required";
      } else if (values.password.length < 8) {
        errors.password = "Minimum password length is 8";
      }
    }

    if (step === "otp") {
      if (!otp || otp.length !== 6) {
        errors.otp = "Enter a valid 6-digit OTP";
      }
    }

    return errors;
  };


  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  }, []);

  const togglePasswordNew = useCallback(() => {
    setPasswordShow((prev) => !prev);
  }, []);

  console.log(regField, "regField");

  const sendOTP = useCallback(async () => {
    const errors = validate(formValues, "initial");
    if (Object.keys(errors).length) {
      setFormErrors(errors);
      return;
    }
    setFormErrors({});

    if (otpCooldown > 0) {
      toast.warn(`Please wait ${otpCooldown} seconds to resend OTP`);
      return;
    }

    try {
      const res = await verifyNumber({ mobileNumber: formValues.mobileNumber }, (err) => {
        toast.error(err);
      });

      if (res?.data?.success) {
        setOtpField(true);
        toast.success(res.data.message);
        setOtpCooldown(60); // cooldown 60 seconds
        const interval = setInterval(() => {
          setOtpCooldown((prev) => {
            if (prev <= 1) {
              clearInterval(interval);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      }
    } catch (err) {
      toast.error(err?.response?.data?.err || "Failed to send OTP");
    }
  }, [formValues, otpCooldown]);

  const verifyOTP = useCallback(async () => {
    const errors = validate(formValues, "otp");
    if (Object.keys(errors).length) {
      setFormErrors(errors);
      return;
    }
    setFormErrors({});

    try {
      const res = await verifyOtp({ mobileNumber: formValues.mobileNumber, Otp: otp });
      if (res?.data?.success) {
        toast.success(res.data.message);
        setRegField(true);
        setOtpField(false);
      }
    } catch (err) {
      toast.error(err?.response?.data?.err || "Invalid OTP");
    }
  }, [formValues, otp]);

  const newRegistration = useCallback(() => {
    const errors = validate(formValues, "registration");
    if (Object.keys(errors).length) {
      setFormErrors(errors);
      return;
    }
    setFormErrors({});

    hospitalReg(
      dispatch,
      {
        labEmail: formValues.labEmail,
        labName: formValues.labName,
        mobileNumber: formValues.mobileNumber,
        password: formValues.password,
      },
      (res) => {
        if (res.success) {
          toast.success(res.message);
          navigate("/login");
        } else {
          toast.error(res);
        }
      }
    );
  }, [formValues, dispatch, navigate]);

  return (
    <section className="main_container">

      <div className="login_form">
        <div className="login-form">
          <h3>Join Now.</h3>
          <div className="ui main_form">
            <div className="form_field">
              <label htmlFor="number">
                Lab Name <span className="text-red"> * </span>{" "}
              </label>
              <input
                type="text"
                placeholder="Enter Lab Name"
                readOnly={regField}
                value={formValues.labName}
                name="labName"
                onChange={handleChange}
              />
              <p className="error_msg text-red">
                {formErrors.labName}
              </p>
            </div>
            <div className="form_field">
              <label>
                Lab Email <span className="text-red"> * </span>{" "}
              </label>
              <input
                type="email"
                placeholder="Enter Lab Email"
                readOnly={regField}
                value={formValues.labEmail}
                name="labEmail"
                onChange={handleChange}
              />
              <p className="error_msg text-red">
                {formErrors.labEmail}
              </p>
            </div>
            <div className="form_field">
              <label htmlFor="number">
                Lab Contact <span className="text-red"> * </span>{" "}
              </label>
              <input
                type="text"
                placeholder="Enter Contact Number"
                readOnly={regField}
                name="mobileNumber"
                value={formValues.mobileNumber}
                onChange={handleChange}
              />
              <p className="error_msg text-red">
                {formErrors.mobileNumber}
              </p>
            </div>

            {otpField && (
              <div className="mt-2 otp-div">
                <OtpInput
                  value={otp}
                  inputType="number"
                  onChange={setOtp}
                  numInputs={6}
                  inputStyle={{
                    minWidth: 48,
                    width: 50,
                    height: 48,
                    margin: "0 4px",
                    padding: 5,
                    borderRadius: "5px"
                  }}
                  renderSeparator={<span> </span>}
                  renderInput={(props) => <input {...props} />}
                />
                <p
                  className="verify-mail submit-otp"
                  onClick={sendOTP}
                  style={{ cursor: otpCooldown ? "not-allowed" : "pointer" }}
                >
                  Resend OTP {otpCooldown > 0 && `(${otpCooldown}s)`}
                </p>
                <p className="error_msg text-red">{formErrors.otp}</p>
              </div>
            )}


            {regField && (
              <div className="form_field">
                <label htmlFor="Password">
                  Password
                  <span className="text-red password-info">
                    (Password must be 8-16 characters in length)
                  </span>
                </label>
                <div className="password-container">
                  <input
                    name="password"
                    type={passwordShow ? "text" : "password"}
                    placeholder="Enter Password"
                    onChange={handleChange}
                    value={formValues.password}
                    autoComplete="nope"
                  />
                  <button className="password-toggle-btn-login" onClick={togglePasswordNew}>
                    {passwordShow ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                <p className="error_msg text-red">{formErrors.password}</p>
              </div>

            )}
          </div>

           {otpField && <button onClick={verifyOTP} className="btn-login">Verify OTP</button>}
          {!otpField && !regField && <button onClick={sendOTP} className="btn-login">Send OTP</button>}
          {regField && <button onClick={newRegistration} className="btn-login">Registration</button>}

          <div className="signup-route">
            <Link to="/login" className="btn-forget">
              Already Registered ? Login..
            </Link>
          </div>
        </div>
      </div>
    </section>

  );
};

export default Signup;
